export enum TaskPauseReason {
  RedLight = 'RedLight',
  GladHandle = 'GladHandle',
  TrailerMove = 'TrailerMove',
  TrailerInDoor = 'TrailerInDoor',
  Other = 'Other',
}
